import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route } from '@app/core/route.service';
import { DeviceMetadataComponent } from './device-metadata.component';

const routes: Routes = Route.withShell([
  { path: 'device-metadata', component: DeviceMetadataComponent, data: { title: 'Device Metadata' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)],
  ],
  exports:[RouterModule],
})
export class DeviceMetaDataRoutingModule { }
